import React from 'react'

const MoreButton = ({ onClick }) => {
  const { containerStyle } = styles
  return (
    <a style={containerStyle} onClick={() => onClick()}>
      <h4 style={{ color: '#3b424d' }}>Läs in fler...</h4>
    </a>
  )
}

const styles = {
  containerStyle: {
    width: '100%',
    height: 64,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}

export { MoreButton }



// WEBPACK FOOTER //
// ./src/components/common/bookingSchemeComponents/MoreButton.js